// How a per-entry QA verdict is shown (DEV-3040).
//
// "Approved" is not a stored status: it is an accepted entry that has since been delivered to the
// client, which the PM's Approve button records as approvedAt. Everything reading a verdict has to
// collapse those two fields the same way, so it is done here once.

export const REVIEW_LABELS = {
	pending: "Pending review",
	accepted: "Accepted",
	approved: "Approved",
	rejected: "Rejected",
	needsRework: "Rework",
	resubmitted: "Resubmitted"
};

export const REVIEW_BADGES = {
	pending: "text-bg-secondary",
	accepted: "text-bg-success",
	approved: "text-bg-success",
	rejected: "text-bg-danger",
	needsRework: "text-bg-warning",
	resubmitted: "text-bg-info"
};

// The verdicts an inspector can pick, in the order the mockup puts them.
export const SETTABLE_STATUSES = ["accepted", "rejected", "needsRework"];

export const SETTABLE_LABELS = {
	accepted: "Accept",
	rejected: "Reject",
	needsRework: "Rework"
};

export function displayStatus(entry) {
	const status = entry.reviewStatus || "pending";
	if (status === "accepted" && entry.approvedAt) {
		return "approved";
	}
	return status;
}

// The contributor may only work on an entry that is waiting for them: one QA has not looked at yet
// (pending) and one QA has handed back (needsRework). Everything else is out of their hands —
// accepted has passed and may already have gone to the client, rejected is QA's decision and not a
// task handed back to them, and resubmitted is already waiting on QA again. crowd-back-end refuses
// the write either way (util/entryReview.js); this greys the controls so it is visible first.
const CONTRIBUTOR_EDITABLE_STATUSES = ["pending", "needsRework"];

export function lockedForContributor(entry) {
	return !CONTRIBUTOR_EDITABLE_STATUSES.includes(entry.reviewStatus || "pending");
}

export function contributorLockReason(entry) {
	switch (entry.reviewStatus || "pending") {
		case "accepted":
			return "This entry has been accepted by QA and can no longer be changed.";
		case "rejected":
			return "This entry has been rejected by QA. There is nothing to do about it \u2014 it is simply not paid for.";
		case "resubmitted":
			return "This entry is waiting for QA to look at it again and can no longer be changed.";
		default:
			return "This entry can no longer be changed.";
	}
}

// The inspector's own limit. An approved entry has gone to the client and has been paid for, so the
// verdict on it is settled — changing it would take back an asset that has already left. Approving
// stays repeatable for everything QA has accepted since; only what was already sent is closed.
// crowd-back-end refuses the write either way (util/entryReview.js), this greys the controls so it
// is visible before clicking.
export function lockedForInspector(entry) {
	return Boolean(entry.approvedAt);
}

export const INSPECTOR_LOCK_REASON = "This entry has already been approved and delivered to the client. Undeliver the submission first if it has to change.";

// The same thing in the width of a table cell — the Approved badge above it has already said what
// state the entry is in, so this only has to say why the controls are dead.
export const INSPECTOR_LOCK_NOTE = "Undeliver the submission to change this.";
